var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_8263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 9.3152C4.71875 8.42339 4.96446 7.58797 5.39132 6.87264V3.83838H2.35706C1.15278 5.40241 0.5 7.30855 0.5 9.3152C0.5 11.3218 1.15278 13.228 2.35706 14.792H5.39132V11.7577C4.96446 11.0424 4.71875 10.207 4.71875 9.3152Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.0965L7.39062 16.2058L9.5 18.3152C11.5067 18.3152 13.4128 17.6624 14.9768 16.4582V13.4271H11.9458C11.2242 13.8555 10.3853 14.0965 9.5 14.0965Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39144 11.7577L2.35718 14.792C2.59561 15.1016 2.85524 15.3982 3.13617 15.6791C4.83605 17.379 7.09614 18.3151 9.50012 18.3151V14.0964C7.75553 14.0964 6.22647 13.157 5.39144 11.7577Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.31515C18.5 8.76759 18.4504 8.21901 18.3526 7.68471L18.2735 7.25232H9.5V11.4711H13.7698C13.3552 12.2959 12.7176 12.9688 11.9457 13.4271L14.9768 16.4581C15.2864 16.2197 15.583 15.9601 15.8639 15.6791C17.5638 13.9792 18.5 11.7191 18.5 9.31515Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8809 5.93431L13.2537 6.30718L16.2369 3.3241L15.864 2.95124C14.1641 1.25136 11.904 0.315186 9.5 0.315186L7.39062 2.42456L9.5 4.53394C10.7771 4.53394 11.9778 5.03126 12.8809 5.93431Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 4.53394V0.315186C7.09593 0.315186 4.83584 1.25136 3.13593 2.9512C2.85499 3.23213 2.59536 3.52868 2.35693 3.83837L5.3912 6.87263C6.22627 5.47331 7.75532 4.53394 9.49991 4.53394Z",
    fill: "#EB4132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_8263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.315186)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a289bb34f1b3eb750818aa3ebe5b64c1.svg";
export { ForwardRef as ReactComponent };